import { NgModule, isDevMode, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ToastrModule, provideToastr } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomerSupportButtonComponent } from './components/customer-support-button/customer-support-button.component';
import { OfflineComponent } from './components/offline/offline.component';
import { QrScannerComponent } from './components/qr-scanner/qr-scanner.component';
import { SupportChatWidgetComponent } from './components/support-chat/support-chat.component';
import { SupportChatNoticeComponent } from './components/support-chat-notice/support-chat-notice.component';
import { ToastComponent } from './components/toast/toast.component';
import { UpdatePwaButton } from './components/update-pwa-button.component';
import { SharedModule } from './shared/shared.module';
import { AuthStore } from './store/auth.store';

export function initializeApp(authStore: AuthStore) {
  return () => authStore.loadAppConfig();
}

// const config: SocketIoConfig = {
// 	url: environment.api_url, options: {
// 		path: '',
// 		reconnectionAttempts: 4,
// 		autoConnect: true,
// 		reconnectionDelay: 1000,
// 	}
// };

@NgModule({
	declarations: [AppComponent, ],
	imports: [
    OfflineComponent,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    // SocketIoModule.forRoot(config),
    ToastrModule.forRoot(),
    QrScannerComponent,
    CustomerSupportButtonComponent,
    SupportChatWidgetComponent,
    SupportChatNoticeComponent,
    ToastComponent,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OfflineComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerImmediately'
    }),
    UpdatePwaButton
  ],
  bootstrap: [AppComponent],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(),
    provideToastr({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
      tapToDismiss: false,
			enableHtml: true,
			
    }),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthStore],
      multi: true
    }
  ]
})
export class AppModule {}
